<template>
 <vs-row
    vs-type="flex"
    vs-justify="flex-start"
    vs-align="flex-start"
    vs-w="12"
  >
    <vs-card>

      <vs-table
        multiple
        v-model="selected"
        :data="question_details"
        stripe
      >
        <template slot="header">
            <h3>Question List</h3>
            <!-- {{question_details}} -->
          </template>
        <template slot="thead">
          <vs-th>Question Title</vs-th>
          <vs-th>Question Type</vs-th>
          <vs-th>Question Marks</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].question_title }}
            </vs-td>

            <vs-td>
              {{ data[indextr].input_type_id_obj.label }}
            </vs-td>

            <vs-td>
              {{ data[indextr].point }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

        <vs-button v-if="query_page.has_next" @click="loadMore" style="float:right">Load More Data</vs-button>

      <vs-button class="my-4" @click="exportQuestion">Export to Course Builder</vs-button>
          <!-- <pre>{{ selected }}

            {{query_page}}
          </pre> -->

    </vs-card>
    </vs-row>
</template>
<script>
import { fetchQuestionBank } from '@/api/question-bank'
export default {
  name: 'question-modal',
  props: {
    subject_id:{
      required:true
    }
  },
  data () {
    return {
      // 'question_bank_data':[],
      selected: [],
      active: false,
      select_filter_id: '',
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],

      question_details: [],
      query_page:{
        'total': '',
        'limit': 10,
        'has_next': false,
        'current_page': 1,
        'next_page_url': null,
        'previous_page_url': ''
      }
    }
  },
  mounted () {
    this.fetchQuestionBankList()
  },
  // computed: {
  //   isQuestionModalActiveLocale: {
  //     get () {
  //       return this.isQuestionModalActive
  //     },
  //     set () {

  //       this.$emit('closeQuestionBank', false)

  //     }
  //   }
  // },
  methods: {
    async fetchQuestionBankList () {
      const customerId = this.$store.getters.customerId
      const payload = {
        subject_id: this.subject_id
      }
      const { data } = await fetchQuestionBank(customerId, payload, this.query_page.current_page)

      const question_details = data.data.question_details
      // this.question_details.forEach({


      // })

      this.question_details = data.data.question_details
      this.query_page = data.data.meta



    },
    exportQuestion () {
      //
      if (this.selected.length) {

        const obj = this.selected
        this.$emit('closeQuestionBank', obj)

      } else {

      }


    },
    loadMore () {
      this.loadMoreData()


    //   const customerId = this.$store.getters.customerId
    //   const payload = {
    //     subject_id: '36'
    //   }
    //   const { data } = await fetchQuestionBank(customerId, payload,  this.query_page.current_page + 1)
    //

    },
    async loadMoreData () {
      const customerId = this.$store.getters.customerId
      const payload = {
        subject_id:this.subject_id
      }
      const { data } = await fetchQuestionBank(customerId, payload,  this.query_page.current_page + 1)
      // this.question_details = [...this.question_details, data.data.question_details]


      this.question_details.push(...data.data.question_details)


      this.query_page = data.data.meta



    }

  }
}
</script>

<style>
.tag-holder {
  border: 1px solid grey;
  display: inline-flex;
  margin: 0 2px;
  padding: 2px 10px;
  border-radius: 5px;
}
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 111111;
}
</style>
